import { render, staticRenderFns } from "./BulkEditing.vue?vue&type=template&id=7b48d452&scoped=true"
import script from "./BulkEditing.vue?vue&type=script&lang=js"
export * from "./BulkEditing.vue?vue&type=script&lang=js"
import style0 from "./BulkEditing.vue?vue&type=style&index=0&id=7b48d452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b48d452",
  null
  
)

export default component.exports